import { render, staticRenderFns } from "./app-detail-pricetrend.vue?vue&type=template&id=61760142&scoped=true&"
import script from "./app-detail-pricetrend.vue?vue&type=script&lang=js&"
export * from "./app-detail-pricetrend.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-pricetrend.vue?vue&type=style&index=0&id=61760142&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61760142",
  null
  
)

export default component.exports